module.exports = __webpack_public_path__ + "static/img/my.9dec709f.png";